import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  BfxBaseBlotterService,
  BfxMultiBlotterService,
  SKIP_INIT_DATA_SERVICE,
} from "../../bfx-base-blotter/bfx-base-blotter.service";
import {
  LimitClientTradePrimaryLookupService,
  TradeTableDefinitionFactory,
} from "shared/cubiq-services";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AllocationTableDefinitionFactory } from "shared/cubiq-services/model/AllocationTableDefinitionFactory";
import { AllocationInfoDetails } from "shared/cubiq-services/action/impl/DetailedOrderStatusRequestPrimaryService";

export type OrderAllocationContainer = {
  allocationData: AllocationInfoDetails[];
};

/**
 * Per instance service for Allocation blotters that stores all allocations for a single
 * Order Details blotter
 */
@Injectable()
export class BfxAllocationBlotterService extends BfxBaseBlotterService {
  /** Priming guard */
  private hasAllocations: boolean = false;

  constructor(public tableDefinitionService: AllocationTableDefinitionFactory) {
    super(SKIP_INIT_DATA_SERVICE, tableDefinitionService);
    this.createTableDefinition();
  }

  /**
   * Initialise and/or update the allocations in the data model
   * @param order
   */
  public setOrder(order: OrderAllocationContainer) {
    if (order) {
      const allocations = order.allocationData;
      if (allocations) {
        if (!this.hasAllocations) {
          // THis is first time setting the allocations
          this.hasAllocations = true;
          this.onInitialPrime(allocations);
          this.resolvePriming(this._readyResFn, this._readyRejFn);
        } else {
          // Need to purge the old allocations and add these new ones
          this._rawData = Object.create(null);
          this.onFullUpdateEvent(allocations, true);
        }
      }
    }
  }
}
